<app-floorplan-item-details
  [extent]="extent()"
  [isExtendable]="true"
  [floorplanItem]="gasWarningCenter()"
  [productId]="gasWarningCenter().config.mainProductId"
  [showDiscontinuedWarning]="isDiscontinued()"
  (toggleExtendedButtonClicked)="toggleExtendedButtonClicked.emit()"
>
  <div data-main>
    <app-floorplan-item-attachments-button
      [productItems]="productItems()"
      [attachments]="attachments()"
      [customProducts]="gasWarningCenter().products"
    ></app-floorplan-item-attachments-button>
    <app-floorplan-item-group [floorplanItem]="gasWarningCenter()"></app-floorplan-item-group>
  </div>
  @if (extent() !== SidesheetExtent.None) {
    <div data-extended>
      <app-floorplan-gas-warning-center-detail-form
        [gasWarningCenter]="gasWarningCenter()"
      ></app-floorplan-gas-warning-center-detail-form>
    </div>
  }
</app-floorplan-item-details>
